<template v-slot:header>
  <v-layout>
    <v-flex xs12>
      <v-flex class="note-header-left">
        <UserAvatar v-if="note.author" avatarOnly :userId="note.author.id" :avatarURL="note.author.avatarUrl" :name="note.author.displayName" size="30px" class="mr-0 ml-2 note-avatar"></UserAvatar>
        <h3 class="ml-2 pl-1 pt-1 block" v-if="!editing">
          {{ note.subject }}
        </h3>
        <v-text-field v-else @click.stop solo label="Subject" class="mt-0 ml-2 pt-1 d-inline-block" v-model="note.subject" :rules="[requiredRule]"> </v-text-field>
      </v-flex>
      <v-flex class="pr-3 note-actions">
        <v-tooltip top color="secondary" class="pr-2">
          <v-btn v-if="editing" @click.stop="enterEditMode()" icon slot="activator" class="ma-0 d-inline-block editing">
            <v-icon color="secondary">edit</v-icon>
          </v-btn>
          <v-btn v-if="!editing" @click.stop="enterEditMode()" slot="activator" icon class="ma-0 d-inline-block">
            <v-icon color="secondary">edit</v-icon>
          </v-btn>
          <span>Edit note</span>
        </v-tooltip>
        <v-tooltip top color="secondary" class="pr-2">
          <v-btn @click.stop="deleteDialog = true" slot="activator" icon class="ma-0 mr-2 d-inline-block">
            <v-icon color="secondary">delete</v-icon>
          </v-btn>
          <span>Delete</span><delete-dialog :isOpen="deleteDialog" itemType="case note" v-on:delete-item="deleteNote"></delete-dialog>
        </v-tooltip>
        <span class="d-inline body-1 opacity-54"> {{ formatDate(note.updatedAt) }}</span>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"
import UserAvatar from "@/components/Users/UserAvatar.vue"
import DeleteDialog from "@/components/shared/deleteDialog"
export default {
  components: { DeleteDialog, UserAvatar },
  data: () => ({
    deleteDialog: false,
    requiredRule: (value) => !!value || "Subject required.",
  }),
  props: {
    note: {
      type: Object,
      required: true,
    },
    userPreferences: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      required: true,
    },
    noteIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    formatDate(date) {
      if (this.userPreferences.dateTimeFormat) {
        return Helpers.formatDate(date, this.userPreferences.dateTimeFormat)
      } else {
        return Helpers.formatDate(date, "Do MMM YYYY HH:mm")
      }
    },
    enterEditMode() {
      this.$store.dispatch("editCaseNote", { noteIndex: this.noteIndex, editing: true })
    },
    deleteNote(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        this.$store.dispatch("deleteCaseNote", { noteIndex: this.noteIndex, editing: true })
      }
    },
  },
}
</script>

<style lang="scss">
.note-actions {
  .v-tooltip {
    padding-right: 5px;
  }
}
</style>
